import { LlmDatadogLoggingDetails } from '@/libs/features/llm/types'
import type { PropType } from 'vue'

export type LlmFeedback = {
  feedbackId: string
  llmRawLogId: string
  wasHelpful: boolean
  structuredFeedbackReason?: string
  feedbackReasonDetails?: string
}

export enum FeedbackScreen {
  COARSE = 'coarse',
  GRANULAR = 'granular',
  CUSTOM = 'custom',
  SUBMITTED = 'submitted',
}

export const LLM_FEEDBACK_PROPS = {
  rawLogId: {
    type: String,
    required: true,
  },
  datadogLoggingDetails: {
    type: Object as PropType<LlmDatadogLoggingDetails>,
    required: true,
  },
  extraFeedbackReasons: {
    type: Array as PropType<string[]>,
    default: () => [],
  },
} as const
